import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { adminApi } from '@/lib/adminApi';

const KINDS = [['purchase', 'Paid Purchase Confirmation'], ['free', 'Free Download Delivery'], ['reissue', 'New Link (Resend / Renewal)']];

export default function EmailPreviewPanel() {
  const [kind, setKind] = useState('purchase');
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    adminApi.get('/admin/digital-products/email-preview', { params: { kind } }).then((r) => setData(r.data)).catch(() => toast.error('Failed to load preview'));
  }, [kind]);
  return (
    <div data-testid="dp-email-preview-panel">
      <p className="text-sm text-[#666] mb-4">Previews use sample data. Nothing is sent to customers. Live emails are delivered through Resend with your real product and download link.</p>
      <div className="flex flex-wrap gap-2 mb-5">
        {KINDS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setKind(k)} data-testid={`dp-email-preview-${k}`}
            className={`text-xs tracking-[0.14em] uppercase px-4 py-1.5 rounded-full border ${kind === k ? 'bg-[#111] text-[#FAF8F5] border-[#111]' : 'bg-white text-[#555] border-[#eae4d8]'}`}>{l}</button>
        ))}
      </div>
      <div className="bg-white border border-[#eae4d8] rounded-xl overflow-hidden max-w-3xl">
        <div className="px-5 py-3 border-b border-[#eae4d8] text-sm"><span className="text-[#888]">Subject:</span> <span data-testid="dp-email-preview-subject">{data?.subject || '…'}</span></div>
        {data ? <iframe title="Email preview" srcDoc={data.html} className="w-full h-[900px] border-0" sandbox="" data-testid="dp-email-preview-frame" /> : <div className="py-20 text-center text-[#888]">Loading…</div>}
      </div>
    </div>
  );
}
